import axios from '../utils/axios';

export default function getFreeListingSignedUrl(adminId, params, onDownloadProgress) {
    return axios.get(`/admin/${adminId}/get-free-listing-report-url`, { 
        params, 
        responseType: 'blob', 
        onDownloadProgress: onDownloadProgress,
    });
}